import {Routes} from '@angular/router';
import {DetailUserComponent} from './components/detail-user/detail-user.component';
import {DetailCompanyComponent} from './components/detail-company/detail-company.component';
import {DataFactoryComponent} from './components/data-factory/data-factory.component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import { HomeGuard } from '@core/services/home.guard';
import { AdminPanelUserDetailLinkComponent } from './components/admin-panel-user-detail-link/admin-panel-user-detail-link.component';


export const adminPanelRoutes: Routes = [
  {
      path: '',
      component: PlatformLinkCreatorComponent,
      canActivate: [HomeGuard],
  },
  {
    path: 'user',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-factory',
    component: DataFactoryComponent
  },
  {
    path: 'online-users',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'online-users/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'client-manager',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'client-manager/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'scim-clients',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'scim-clients/:companyId',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':companyId']}
  },
  {
    path: 'user/:userName',
    component: AdminPanelUserDetailLinkComponent,
    data: {dynamicParameterToResolve: [':userName']}
  },
  {
    path: 'company',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'company/:companyId',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':companyId']}
  },
  {
    path: 'company-360',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'company-360/:companyId',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':companyId']}
  },
  {
    path: 'dashboard-settings',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'company-snapshot',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'in-app-purchase/user',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'in-app-purchase/user/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'in-app-purchase/company',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'in-app-purchase/company/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'in-app-purchase/firm',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'in-app-purchase/firm/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'in-app-purchase/pending',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'in-app-purchase/pending/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'in-app-purchase',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'billing-accounts',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'administrative-modification',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'merge',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'pod-size',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'gateway',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'orbitax-connect',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'orbitax-connect-config',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'email-blast',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'email-blast/:emailBlastId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'email-blast/email-thread',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'email-blast/email-thread/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'sandbox',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'sandbox/:sandboxId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'billing-accounts',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'billing-accounts/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'drive/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'rfp-library',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'rfp-cases',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'rfp-cases/:CaseId',
    component: PlatformLinkCreatorComponent
  }
];
